import * as E from 'io-ts/Encoder';

export const OneToBoolean: E.Encoder<boolean, string> = {
    encode: s => s === '1',
};
